/*jshint esversion: 6 */
document.addEventListener("DOMContentLoaded", function () {

    // make the sticky magic happen on the menu
    let scrolled_val = 0;

    // for the initial position
    scrolled_val = window.scrollY;
    if(scrolled_val > 49) { 
        document.querySelector('header.sticky-top').classList.add('is-pinned');
    }
    
    // for when it scrolls
    window.addEventListener('scroll', (e) => {
        scrolled_val = window.scrollY;
        if(scrolled_val <= 49) { 
            document.querySelector('header.sticky-top').classList.remove('is-pinned');
        } else {
            document.querySelector('header.sticky-top').classList.add('is-pinned');
        }
    });

    // Enable tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // Tooltip me if truncated text being truncated
    function callTooltip(element,elementTitle) {
        const tooltip = new bootstrap.Tooltip(element, {
            title: elementTitle,
            customClass: 'card-tooltip',
        });
        element.addEventListener('mouseenter', () => {
            tooltip.toggle();
        });
        element.addEventListener('mouseleave', () => {
            tooltip.toggle();
        });
    }
    const textTruncateElements = document.querySelectorAll('.text-truncate');

    for (const textTruncateElement of textTruncateElements) {
        if (textTruncateElement.scrollWidth > textTruncateElement.clientWidth) {
            const textTruncateTitle = textTruncateElement.textContent;
            callTooltip(textTruncateElement,textTruncateTitle);
        }
    }


    // Speedbump Links
    const speedbumpLinks = document.querySelectorAll('.speed-bump');
    const speedbumpModal = new bootstrap.Modal(document.getElementById('speedbumpModal'));
    const speedbumpRelay = document.getElementById('speedbump-relay');

    speedbumpLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const href = this.getAttribute('href');
            speedbumpRelay.setAttribute('href', href);
            speedbumpModal.show();
        });
    });
    speedbumpRelay.addEventListener('click', () => {
        speedbumpModal.hide();
    });
});